<div class="maincontainer light-theme">
  <section class="contentcontainer">
    <div class="row">
      <div class="col-12">
        <div class="page-header">
          <h1 class="title">Contracts</h1>

          @if (isGlobalAdmin) {
            <div class="header-action">
              <aecom-button
                innerClass="btn blue btn-icon solid ml-auto"
                class="ml-auto"
                (click)="createContract()"
              >
                Add Contract
              </aecom-button>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <aecom-table
          [ngValue]="tableData"
          (ngValueChange)="tableRows = $event"
          theme="'light'"
          innerClass="list cus"
          [canSearch]="true"
          [columnFilters]="columnFilters"
        >
          <thead>
            <tr>
              @for (hCol of tableHeader; track hCol) {
                @if (hCol.Type !== columnType.Hide) {
                  <th
                    [ngClass]="
                      hCol.Type === columnType.BoroughIcon
                        ? 'tablehead'
                        : 'sort'
                    "
                    id="{{ hCol.Name }}"
                  >
                    {{ hCol.Header }}
                  </th>
                }
              }
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (bRow of tableRows; track bRow) {
              <tr class="pointer">
                @for (hCol of tableHeader; track hCol) {
                  @if (hCol.Type !== columnType.Hide) {
                    <td (click)="contractClick(bRow)">
                      @if (hCol.Type === columnType.BoroughIcon) {
                        <div style="align-items: center; display: flex">
                          <img
                            style="width: 40px; height: 40px; margin-left: 10px"
                            src="{{ getBoroughIcon(bRow[hCol.Name]) }}"
                          />
                        </div>
                      }
                      @if (hCol.Type !== columnType.BoroughIcon) {
                        <span class="tr_Item">
                          {{ bRow[hCol.Name] }}
                        </span>
                      }
                    </td>
                  }
                }
                <td>
                  <a class="btn" (click)="contractSettingClick(bRow)">
                    <i class="icon icon-basic_gear icon-blue icon-lg"></i>
                  </a>
                  <!-- <i class="icon icon-basic_gear icon-blue icon-lg"></i> -->
                </td>
              </tr>
            }
          </tbody>
        </aecom-table>
      </div>
    </div>

    <div class="tablecontent row mx-0"></div>
  </section>
</div>

@if (showEditContract) {
  <div class="up-contentcontainer">
    @if (showEditContract) {
      <div
        class="editContractWindow"
        (clickOutside)="closeEditContractWindow()"
      >
        <app-contract-edit
          [contract]="selectContract"
          (close)="closeEditContractWindow()"
          [(firstOpen)]="firstOpen"
          [(activeSave)]="activeSave"
          [currentPath]="'contractList'"
        ></app-contract-edit>
      </div>
    }
  </div>
}
